import React from 'react';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { RequestInterceptor } from './components/RequestInterceptor';
import {MapsManagement} from "./components/MapsManagement";



function App() {
  return (
    <div className="App">
        <RequestInterceptor>
            <MapsManagement></MapsManagement>
        </RequestInterceptor>
    </div>
  );
}

//Activate JSon local database: json-server --watch db.json --port 3001
//Run React App: npm start

export default App;
